export const BACKEND_URL = `${process.env.DOMAIN}:${process.env.REACT_APP_BACKEND_PORT}`;
export const MEDIA_URL = process.env.REACT_APP_MEDIA_URL;
export const GRAPHQL_ENDPOINT = process.env.REACT_APP_GRAPHQL_URL;
